import Vue from 'vue';
import Vuex from 'vuex';

import auth from '@/store/modules/auth';
import layout from '@/store/modules/layout';
import resource from '@/store/modules/resource';
import utils from '@/store/modules/utils';
import modals from '@/store/modules/modals';
import addCandidateModals from '@/store/modules/addCandidateModals';

// import createLogger from "vuex/dist/logger"

Vue.use(Vuex);

// const plugins = [createLogger({})]

export default new Vuex.Store({

  modules: {
    auth,
    layout,
    modals,
    resource,
    utils,
    addCandidateModals,
  },

  state: {},
  getters: {},
  mutations: {},
  actions: {},
});
